export function printPromotionKitPoster(windowRef: Window = window): void {
  const className = 'promotion-kit-print-mode';
  windowRef.document.body.classList.add(className);
  try {
    windowRef.print();
  } finally {
    windowRef.document.body.classList.remove(className);
  }
}
